(function () {
  function init() {
    var header = document.querySelector('[data-fa-header]');
    if (!header || header.dataset.faInit === 'true') return;
    header.dataset.faInit = 'true';

    /* =====================================================
       Dropdown controller — mega panels + More share one
       state machine with hover intent.
       ===================================================== */
    var OPEN_DELAY = 80;
    var CLOSE_DELAY = 250;
    var entries = [];
    var active = null;   // currently open entry
    var pinned = false;  // opened/locked via click or keyboard
    var openTimer = null;
    var closeTimer = null;

    function clearTimers() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      openTimer = null;
      closeTimer = null;
    }

    function setOpen(entry, open) {
      entry.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      entry.panel.hidden = !open;
    }

    function closeAll() {
      clearTimers();
      entries.forEach(function (entry) { setOpen(entry, false); });
      active = null;
      pinned = false;
    }

    function openEntry(entry, viaPointer) {
      clearTimers();
      if (active && active !== entry) setOpen(active, false);
      active = entry;
      pinned = !viaPointer;
      setOpen(entry, true);
    }

    function registerDropdown(wrapper, toggle, panel) {
      if (!toggle || !panel) return null;
      var entry = { wrapper: wrapper, toggle: toggle, panel: panel };
      entries.push(entry);

      // The panel is a DOM child of the wrapper, so hovering the panel keeps
      // the wrapper "entered"; the close grace period covers the visual gap
      // between the trigger and the absolutely positioned panel.
      wrapper.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        closeTimer = null;
        if (active === entry) return;
        clearTimeout(openTimer);
        if (active) {
          openEntry(entry, true); // already browsing: switch instantly
        } else {
          openTimer = setTimeout(function () { openEntry(entry, true); }, OPEN_DELAY);
        }
      });

      wrapper.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        openTimer = null;
        if (active === entry && !pinned) {
          closeTimer = setTimeout(closeAll, CLOSE_DELAY);
        }
      });

      toggle.addEventListener('click', function () {
        if (active === entry) {
          if (!pinned) { pinned = true; return; } // hover-opened: click pins instead of closing
          closeAll();
        } else {
          openEntry(entry, false); // touch/keyboard path, works without hover
        }
      });

      return entry;
    }

    header.querySelectorAll('[data-fa-mega]').forEach(function (wrapper) {
      registerDropdown(
        wrapper,
        wrapper.querySelector('[data-fa-shop-toggle]'),
        wrapper.querySelector('[data-fa-mega-panel]')
      );
    });

    document.addEventListener('click', function (e) {
      if (!header.contains(e.target)) closeAll();
    });

    header.addEventListener('focusout', function (e) {
      if (e.relatedTarget && !header.contains(e.relatedTarget)) closeAll();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (active) {
        var toggle = active.toggle;
        closeAll();
        toggle.focus();
      }
      closeDrawer();
    });

    /* =====================================================
       Mobile drawer
       ===================================================== */
    var drawer = header.querySelector('[data-fa-drawer]');
    var hamburger = header.querySelector('[data-fa-hamburger]');
    var drawerCloseBtn = header.querySelector('[data-fa-drawer-close]');

    var backdrop = document.querySelector('.fa-nav__drawer-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'fa-nav__drawer-backdrop';
      document.body.appendChild(backdrop);
    }

    function openDrawer() {
      drawer.hidden = false;
      requestAnimationFrame(function () {
        drawer.setAttribute('data-open', 'true');
        backdrop.setAttribute('data-open', 'true');
      });
      hamburger.setAttribute('aria-expanded', 'true');
      hamburger.setAttribute('aria-label', 'Close menu');
      document.body.style.overflow = 'hidden';
      if (drawerCloseBtn) drawerCloseBtn.focus();
    }

    function closeDrawer() {
      if (!drawer || drawer.getAttribute('data-open') !== 'true') return;
      drawer.removeAttribute('data-open');
      backdrop.removeAttribute('data-open');
      hamburger.setAttribute('aria-expanded', 'false');
      hamburger.setAttribute('aria-label', 'Open menu');
      document.body.style.overflow = '';
      setTimeout(function () {
        if (drawer.getAttribute('data-open') !== 'true') drawer.hidden = true;
      }, 260);
      hamburger.focus();
    }

    if (hamburger && drawer) {
      hamburger.addEventListener('click', function () {
        if (hamburger.getAttribute('aria-expanded') === 'true') closeDrawer();
        else openDrawer();
      });
      backdrop.addEventListener('click', closeDrawer);
      if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeDrawer);

      // Focus trap while the drawer is open.
      drawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusables = Array.prototype.filter.call(
          drawer.querySelectorAll('a[href], button:not([disabled]), summary'),
          function (el) { return el.offsetParent !== null || el === drawerCloseBtn; }
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });

      // Accordion groups: opening one closes its siblings.
      var groups = drawer.querySelectorAll('details.fa-nav__drawer-group');
      groups.forEach(function (group) {
        group.addEventListener('toggle', function () {
          if (!group.open) return;
          groups.forEach(function (other) {
            if (other !== group && other.open) other.open = false;
          });
        });
      });
    }

    /* =====================================================
       Cart count badge — refresh on Dawn's cartUpdate event
       (quick-add / product form publish it via pubsub.js).
       ===================================================== */
    var cartCount = header.querySelector('[data-fa-cart-count]');
    if (cartCount && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            cartCount.textContent = cart.item_count;
            cartCount.hidden = cart.item_count === 0;
          })
          .catch(function () {});
      });
    }

    /* =====================================================
       Sticky condense — shrink row 1 once scrolled.
       ===================================================== */
    if (header.classList.contains('fa-nav--sticky')) {
      // Fallback for browsers without :has() — sticky lives on the section wrapper.
      var wrapper = header.parentElement;
      if (wrapper && wrapper.classList.contains('shopify-section')) {
        wrapper.classList.add('fa-nav-sticky-wrapper');
      }

      var scrollTicking = false;
      function onScroll() {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
          scrollTicking = false;
          var y = window.scrollY;
          // Hysteresis so the header doesn't jitter at the threshold.
          if (y > 64) header.classList.add('fa-nav--condensed');
          else if (y < 16) header.classList.remove('fa-nav--condensed');
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
